<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <g clip-path="url(#a)">
    <path fill="#171717" d="M5 4.75c0 .156.094.25.25.25h6.5c.125 0 .25-.094.25-.25v-1a.269.269 0 0 0-.25-.25h-6.5a.246.246 0 0 0-.25.25v1Zm.25 2.75h6.5c.125 0 .25-.094.25-.25v-1a.269.269 0 0 0-.25-.25h-6.5a.246.246 0 0 0-.25.25v1c0 .156.094.25.25.25Zm9.344 5c.219-.031.406-.25.406-.5V.5c0-.25-.25-.5-.5-.5h-11A2.487 2.487 0 0 0 1 2.5v11C1 14.906 2.094 16 3.5 16h11c.25 0 .5-.219.5-.5V15a.5.5 0 0 0-.406-.469c-.156-.406-.156-1.625 0-2.031Zm-1.281 0c-.094.563-.094 1.469 0 2H3.5c-.563 0-1-.438-1-1 0-.531.438-1 1-1h9.813Zm.187-11V11h-10c-.375 0-.719.094-1 .219V2.5c0-.531.438-1 1-1h10Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#fff" d="M0 0h16v16H0z"/>
    </clipPath>
  </defs>
</svg>
</template>